"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ErrorBoundary_1 = __importDefault(require("./ErrorBoundary"));
exports.default = ErrorBoundary_1.default;
